export const LOAD_USER = 'user/LOAD';
export const SET_USER = 'user/SET_USER';
export const SET_USER_DETAILS = 'user/SET_USER_DETAILS';
export const SET_USER_PROFILE = 'user/SET_USER_PROFILE';
export const SET_USER_TEAM = 'user/SET_USER_TEAM';
export const SET_EDITED_PROFILE = 'SET_EDITED_PROFILE';
export const SET_USER_AVATAR = 'SET_USER_AVATAR';
export const SET_TIMESTAMP = 'SET_TIMESTAMP';
